export default () => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    backgroundColor: ['black', 'rgba(0, 0, 0, 0.15)'],
});
